// 销售范围
const salesScopeArr = [
  {
    key: 1,
    value: "全平台"
  },
  {
    key: 2,
    value: "仅协议客户"
  }
];
// 订单是否确认
const isConfirmArr = [
  {
    key: 1,
    value: "是"
  },
  {
    key: 0,
    value: "否"
  }
];
import api from "../../../api/product";
import multiImageUpload from "./multiImageUpload.vue";
import { epecToken } from "../../../utils/globalData";
export default {
  data() {
    return {
      uploadUrl: api.fileUploadForProductFile,
      headers: epecToken,
      salesScopeArr,
      isConfirmArr,
      areaArr: [],
      // 税率列表
      taxList: [],
      // 品牌列表
      brandList: [],
      // 单位列表
      unitList: [],
      // 属性列表
      attributeList: []
    };
  },
  components: {
    multiImageUpload
  },
  filters: {
    areaFilter(value, areaArr) {
      if (!value) return "";
      const { salesScopeName = "" } = areaArr.find(item => item.salesScopeId === value) || {};
      return salesScopeName;
    },
    taxRateFilter(value, taxList) {
      if (!value) return "";
      const { taxRate = "" } = taxList.find(item => item.taxRateId === value) || {};
      return taxRate;
    }
  },
  created() {
    this.getAreaArr();
    this.getTaxRateList();
  },
  methods: {
    // 获取区域列表
    async getAreaArr() {
      const { querySalesScopeList } = api;
      await querySalesScopeList()
        .then(res => {
          if (res.code === "200") {
            this.areaArr = [...res.data];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 税率-列表
    async getTaxRateList() {
      let res = await api.getTaxRateList();
      if (res.code === "200") {
        console.log(res.data, "res.datares.data");
        res.data.forEach(item => {
          item.taxRate = item.taxRate + "";
        });
        this.taxList = res.data;
        console.log(this.taxList, "this.taxList");
      }
    },
    //获取品牌列表
    async getBrandList(categoryId) {
      let res = await api.getBrandByCategory({ categoryId });
      if (res.code === "200") {
        this.brandList = res.data;
        const brandObj = this.brandList.find(item => item.brandId === this.editProductForm.brandId);
        Object.assign(this.editProductForm, brandObj);
      }
    },
    //获取属性列表
    async getAttributeData(categoryId) {
      const res = await api.getPropertyByCategory({
        categoryId,
        attributeType: 1
      });
      if (+res.code === 200) {
        this.attributeList = res.data;
      }
    },
    //获取规格列表
    async getPropertyList(categoryId) {
      let res = await api.getPropertyByCategory({
        categoryId,
        attributeType: 2
      });
      if (res.code == 200) {
        this.specificationList = res.data;
      }
    }
  }
};
